import request from '@/utils/request';
import { RecallInterface } from '@api/announcement/type';
import {
  checkOppIdCreatedDateInterface,
  checkOppIdInterface,
  checkOppIdListInterface,
  CompanyResInterface,
  DelProjectInterface,
  GetCompanyInterface,
  GetOppIdListInterface,
  GetProjectListByNoticeCodeInterface,
  NoticeItemInterface,
  OppIdListResInterface,
  ProjectDetailInterface,
  QueryProjectPageInterface,
  SalesTransferDealerInterface
} from './type';

export const createProject = (data: NoticeItemInterface): Promise<{}> => {
  return request({
    url: '/project/create',
    method: 'post',
    data
  });
};

export const updateProject = (data: NoticeItemInterface): Promise<{}> => {
  return request({
    url: '/project/update',
    method: 'post',
    data
  });
};

export const delProject = (data: DelProjectInterface): Promise<{}> => {
  return request({
    url: '/project/del',
    method: 'post',
    data
  });
};

export const projectDetail = (data: ProjectDetailInterface): Promise<{}> => {
  return request({
    url: '/project/detail',
    method: 'post',
    data
  });
};

export const queryProjectPage = (
  data: QueryProjectPageInterface
): Promise<any> => {
  return request({
    url: '/project/queryProjectPage',
    method: 'post',
    data
  });
};

// 查询公告下的项目
export const getProjectListByNoticeCode = (
  data: GetProjectListByNoticeCodeInterface
): Promise<{}> => {
  return request({
    url: '/project/getProjectListByNoticeCode',
    method: 'post',
    data
  });
};

export const checkOppoIdCreatedDate = (
  data: checkOppIdCreatedDateInterface
): Promise<{ oppId: string; code: number; message: string }[]> => {
  return request({
    url: '/project/checkOppoCreatedDate',
    method: 'post',
    data
  });
};

export const checkOppId = (
  data: checkOppIdInterface
): Promise<{ code: number; message: string }> => {
  return request({
    url: '/project/checkOppId',
    method: 'post',
    data
  });
};

export const checkOppIdList = (data: checkOppIdListInterface): Promise<[]> => {
  return request({
    url: '/project/checkOppIdList',
    method: 'post',
    data
  });
};

export const saveLeads = (data: any): Promise<[]> => {
  return request({
    url: '/project/saveLeads',
    method: 'post',
    data
  });
};

export const getLeads = (data: any): Promise<[]> => {
  return request({
    url: '/project/getLeads',
    method: 'post',
    data
  });
};

export const projectRecall = (data: RecallInterface): Promise<[]> => {
  return request({
    url: '/project/recall',
    method: 'post',
    data
  });
};

export const dealerReturnProject = (data: RecallInterface): Promise<[]> => {
  return request({
    url: '/project/dealerReturnProject',
    method: 'post',
    data
  });
};

// 销售转交项目给Dealer
export const salesTransferDealerProject = (
  data: SalesTransferDealerInterface
): Promise<[]> => {
  return request({
    url: '/project/salesTransferDealerProject',
    method: 'post',
    data
  });
};

export const getCompanyList = (
  data: GetCompanyInterface
): Promise<CompanyResInterface[]> => {
  return request({
    url: '/project/getOppoCustomer',
    method: 'post',
    data,
    headers: {
      noLoading: true
    }
  });
};

export const getOppIdList = (
  data: GetOppIdListInterface
): Promise<OppIdListResInterface[]> => {
  return request({
    url: '/project/getOppoProduct',
    method: 'post',
    data
  });
};
